import React from "react";

const PenIconOutline = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7698_97378)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.7457 5.96313C14.4617 5.24717 14.4617 4.08637 13.7457 3.37041L12.8029 2.4276C12.0869 1.71163 10.9261 1.71163 10.2102 2.4276L2.81307 9.8247C2.50867 10.1291 2.3211 10.5309 2.28322 10.9597L2.12183 12.7867C2.05792 13.51 2.66328 14.1154 3.38663 14.0515L5.21357 13.8901C5.64239 13.8522 6.04421 13.6646 6.34861 13.3602L13.7457 5.96313ZM13.0386 4.07751C13.364 4.40295 13.364 4.93059 13.0386 5.25602L12.4055 5.88913L10.2842 3.76781L10.9173 3.1347C11.2427 2.80927 11.7704 2.80927 12.0958 3.1347L13.0386 4.07751ZM9.57707 4.47492L11.6984 6.59624L5.6415 12.6531C5.50314 12.7915 5.32049 12.8768 5.12558 12.894L3.29863 13.0554C3.1953 13.0645 3.10882 12.978 3.11795 12.8747L3.27934 11.0477C3.29656 10.8528 3.38182 10.6702 3.52018 10.5318L9.57707 4.47492Z"
          fill="#737387"
        />
      </g>
      <defs>
        <clipPath id="clip0_7698_97378">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PenIconOutline;
